/*
 * Maison Artsen — barre a paliers du panier : paliers repartis uniformement.
 *
 * Le theme (CartCheckpointsBar dans compiled_assets/scripts.js) recalcule la
 * largeur de la barre proportionnellement aux montants a chaque re-rendu du
 * tiroir, ce qui recolle 60 € et 69,90 € a droite. On remplace update() par la
 * meme regle que le rendu serveur (snippets/cart-checkpoints-bar.liquid) :
 * palier k sur N a la position k/N, remplissage lineaire par segment.
 * On en profite pour marquer les pastilles atteintes (.ma-reached, stylees
 * dans assets/ma-cart.css).
 */
(function () {
  'use strict';

  customElements.whenDefined('cart-checkpoints-bar').then(function () {
    var C = customElements.get('cart-checkpoints-bar');

    C.prototype.update = function () {
      if (this.dataset.isQuantity === 'true') return;
      var rate = (typeof _getPresentmentRate === 'function')
        ? _getPresentmentRate(this.dataset.shopCurrency) : null;
      if (!rate) return;

      var goals;
      try { goals = JSON.parse(this.dataset.goals || '[]'); } catch (e) { return; }
      if (!goals.length) return;

      // US shipping is free at USD 69 (Shopify delivery profile, 18 Sep 2026).
      // Gift thresholds retain their existing conversion and fulfilment rules.
      var badges = this.querySelectorAll('.cart-progress__bar__badge');
      var usShipping = window.Shopify && window.Shopify.country === 'US' && rate.active === 'USD';
      goals = goals.map(function (goal, index) {
        var icon = badges[index] && badges[index].querySelector('.material-symbols-outlined');
        var isShipping = icon && icon.textContent.trim() === 'local_shipping';
        return {
          cents: usShipping && isShipping ? 6900 : goal.cents * rate.rate,
          text: goal.text,
          badgeIndex: index
        };
      });
      if (usShipping) {
        goals.sort(function (a, b) { return a.cents - b.cents || a.badgeIndex - b.badgeIndex; });
      }

      var total = parseFloat(this.dataset.cartTotalCents);
      var next = null, nextIdx = -1;
      for (var i = 0; i < goals.length; i++) {
        var amt = goals[i].cents;
        if (amt > total) { next = { cents: amt, text: goals[i].text }; nextIdx = i; break; }
      }

      var width = 100;
      if (next) {
        var step = 100 / goals.length;
        var prevAmt = nextIdx === 0 ? 0 : goals[nextIdx - 1].cents;
        var prevPos = nextIdx * step;
        width = prevPos + (total - prevAmt) / (next.cents - prevAmt) * step;
        width = Math.max(0, Math.min(100, width));
      }
      var bar = this.querySelector('.cart-progress__bar__progress');
      if (bar) bar.style.width = width + '%';

      for (var j = 0; j < goals.length; j++) {
        var badge = badges[goals[j].badgeIndex];
        if (!badge) continue;
        badge.classList.toggle('ma-reached', total >= goals[j].cents);
        if (usShipping) badge.style.setProperty('--position', ((j + 1) * 100 / goals.length) + '%');
      }

      var txt = this.querySelector('.cart-progress__text');
      if (txt) {
        if (next) {
          var manque = Math.max(0, next.cents - total);
          var montant = (typeof _formatPresentmentMoney === 'function')
            ? _formatPresentmentMoney(manque, rate.active) : '';
          txt.innerHTML = (this.dataset.progressMessage || '')
            .replace('[amount]', '<span>' + montant + '</span>')
            .replace('[next_goal]', next.text || '');
        } else {
          txt.innerHTML = this.dataset.successMessage || '';
        }
      }
    };

    var els = document.querySelectorAll('cart-checkpoints-bar');
    for (var k = 0; k < els.length; k++) els[k].update();
  });
})();

/*
 * Pagination du slider d'upsells : fenetre de 5 points qui suit la slide active.
 * Version deliberement SANS MutationObserver et sans deplacement DOM : un simple
 * tick de lecture qui n'ecrit que scrollLeft (les versions a observer/appendChild
 * ont fait boucler le re-rendu de l'apercu admin le 10/08/2026 — voir site/etat.md).
 */
/*
 * v18.1 : (1) ligne Reductions -> badge economie + ancien total barre sur la
 * ligne Total (comme le SAVE $X de Davinci) ; (2) badges de paiement limites
 * aux moyens europeens, identifiables uniquement par le <title> de leur SVG.
 * Meme pattern surete que la fenetre de points : tick idempotent, ecritures
 * minimales, pas de MutationObserver, aucun bloc de section deplace.
 */
(function () {
  'use strict';
  var KEEP = ['American Express', 'Apple Pay', 'Cartes Bancaires', 'Klarna', 'Mastercard', 'PayPal', 'Visa'];
  function parseEuro(str) {
    /* Montant affiche par Shopify, quelle que soit la devise du marche (EUR "12,34€", USD "$12.34", "1,234.56"). */
    var m = String(str || '').replace(/[^\d.,-]/g, '');
    if (!m) return NaN;
    if (/,\d{1,2}$/.test(m)) m = m.replace(/\./g, '').replace(',', '.');
    else m = m.replace(/,/g, '');
    return parseFloat(m);
  }
  function fmtEuro(n) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    if (cur === 'EUR') return n.toFixed(2).replace('.', ',') + '\u20ac';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(n); }
    catch (e) { return n.toFixed(2) + ' ' + cur; }
  }
  setInterval(function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    /* cadenas devant « Finaliser ma commande » (signal de securite, comme Davinci) */
    var cta = drawer.querySelector('#CartDrawer-Checkout');
    if (cta && !cta.querySelector('.ma-lock')) {
      var lk = document.createElement('span');
      lk.className = 'ma-lock';
      lk.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><rect x="4" y="10" width="16" height="11" rx="2.5"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path></svg>';
      cta.insertBefore(lk, cta.firstChild);
    }

    /* paiements : liste blanche par title SVG */
    var lis = drawer.querySelectorAll('.payment-badges-block li');
    for (var i = 0; i < lis.length; i++) {
      var t = lis[i].querySelector('svg title');
      var want = (t && KEEP.indexOf(t.textContent.trim()) !== -1) ? '' : 'none';
      if (lis[i].style.display !== want) lis[i].style.display = want;
    }

    /* reductions -> badge sur la ligne Total */
    var rows = drawer.querySelectorAll('.cart-drawer__totals__row');
    var redRow = null, totRow = null;
    for (var j = 0; j < rows.length; j++) {
      if (/Réduction|Discount/i.test(rows[j].textContent)) redRow = rows[j];
      var st = rows[j].querySelector('strong');
      if (st && /^total$/i.test(st.textContent.trim())) totRow = rows[j];
    }
    if (!totRow) return;
    var money = totRow.querySelector('.cart-drawer__totals__row__money');
    if (!money) return;
    if (!redRow) {
      var b0 = totRow.querySelector('.ma-eco'); if (b0) b0.remove();
      var o0 = totRow.querySelector('.ma-old-total'); if (o0) o0.remove();
      return;
    }
    redRow.classList.add('ma-hidden');
    var red = parseEuro((redRow.querySelector('.cart-drawer__totals__row__money') || {}).textContent);
    var tot = parseEuro(money.textContent);
    if (isNaN(red) || isNaN(tot) || red <= 0) return;
    var badge = totRow.querySelector('.ma-eco');
    var oldEl = totRow.querySelector('.ma-old-total');
    if (!badge) {
      badge = document.createElement('span'); badge.className = 'ma-eco';
      oldEl = document.createElement('s'); oldEl.className = 'ma-old-total';
      money.parentElement.insertBefore(oldEl, money);
      money.parentElement.insertBefore(badge, oldEl);
    }
    var bTxt = '-' + fmtEuro(red), oTxt = fmtEuro(tot + red);
    if (badge.textContent !== bTxt) badge.textContent = bTxt;
    if (oldEl && oldEl.textContent !== oTxt) oldEl.textContent = oTxt;
  }, 600);
})();

(function () {
  'use strict';
  var DOT_WINDOW = 5;
  setInterval(function () {
    var pag = document.querySelector('cart-drawer .cart-drawer-upsells-container .splide__pagination');
    if (!pag) return;
    var dots = pag.children;
    if (dots.length <= DOT_WINDOW) return;
    var pitch = dots.length > 1 ? dots[1].offsetLeft - dots[0].offsetLeft : 18;
    if (pitch <= 0) pitch = 18;
    if (!pag.classList.contains('ma-dots-window')) pag.classList.add('ma-dots-window');
    /* fenetre = 5 pas exactement, et cible = offsetLeft reel du premier point
       affiche : l'ul a un padding (10 px) qui sinon laisse apparaitre des
       demi-points aux deux bords */
    pag.style.maxWidth = (DOT_WINDOW * pitch) + 'px';
    var active = pag.querySelector('.is-active');
    if (!active) return;
    var idx = Array.prototype.indexOf.call(pag.querySelectorAll('.splide__pagination__page'), active);
    var k = Math.max(0, Math.min(dots.length - DOT_WINDOW, idx - 2));
    var target = dots[k].offsetLeft;
    if (Math.abs(pag.scrollLeft - target) > 1) pag.scrollLeft = target;
  }, 600);
})();
